import { DEFAULT_FILTERS_DATA } from '@app/pages/Analytics/data';
import type { FiltersInterface } from '@app/pages/Analytics/types';
import type { NHeaderProvider } from '@app/providers/HeaderProvider/HeaderProvider.types';

const isReportPeriod = (value: unknown): value is FiltersInterface =>
  typeof value === 'object' &&
  value !== null &&
  'filterMonth' in value &&
  'filterYear' in value &&
  typeof value.filterMonth === 'number' &&
  typeof value.filterYear === 'number';

// До первой загрузки вкладка показывает (загружает) период по умолчанию.
export const getShownReportPeriod = (
  header: NHeaderProvider.Header,
  tabKey: string | null
): FiltersInterface => {
  const period = tabKey ? header[tabKey] : undefined;

  return isReportPeriod(period) ? period : DEFAULT_FILTERS_DATA;
};
